import { size } from 'lodash';
import {
  AutocompleteRequestType,
  AutocompleteSuggestionType,
  GoogleMapsLibraryType,
} from './google-maps';

export const searchLocation = async (
  input: string
): Promise<readonly { label: string; value: string; id: string }[]> => {
  if (size(input) < 3) {
    return [];
  }

  try {
    if (!window.google?.maps) {
      return [];
    }

    const placesLibrary: GoogleMapsLibraryType =
      await window.google.maps.importLibrary('places');

    if (
      placesLibrary.AutocompleteSuggestion &&
      placesLibrary.AutocompleteSessionToken
    ) {
      const { AutocompleteSuggestion, AutocompleteSessionToken } =
        placesLibrary;
      const sessionToken = new AutocompleteSessionToken();

      const request: AutocompleteRequestType = {
        input,
        sessionToken,
        includedRegionCodes: ['ng'],
      };

      const { suggestions } =
        await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);

      return suggestions.map((suggestion: AutocompleteSuggestionType) => ({
        label: suggestion.placePrediction.text.text,
        id: suggestion.placePrediction.placeId,
        value: suggestion.placePrediction.placeId,
      }));
    }
  } catch {
    return [];
  }

  return [];
};
